"use client";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import menu from "@/assets/icons/menu.svg";
import DashboardSidebar from "../business/DashboardSidebar";
import EventSidebar from "../business/EventSidebar";
import Cookies from "js-cookie";
import { useTranslations } from "next-intl";
import { X } from 'lucide-react'

const MobileMenuHeader = ({ header_categories, profil , setModalIsOpen, showStore }: any) => {
  const t = useTranslations();
  const [showModal, setShowModal] = useState(false);
  const [showDashboardSidebar, setShowDashboardSidebar] = useState(false);
  const [showEventSidebar, setShowEventSidebar] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const pathname = usePathname();
  const [profile, setProfile] = useState<any>({});
  const [open, setOpen] = useState<string>("");
  const [token, setToken] = useState<string | null>(null);
 const accessToken = Cookies.get("access_token");
   useEffect(() => {
  const accessToken = Cookies.get("access_token");
  setToken(accessToken || null);
}, []);

  useEffect(() => {
    setShowModal(false);
  }, [pathname]);

  useEffect(() => {
    const getCookieData = () => {
      // Get cookies using js-cookie
      const profileCookie = Cookies.get("profile") || "{}";

      const profileData =
        profileCookie && profileCookie !== "undefined"
          ? JSON.parse(profileCookie)
          : {};

      setProfile(profileData);
    };
    getCookieData();
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        buttonRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setShowModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex md:hidden gap-1 items-center shrink-0">
      <div ref={buttonRef} className="shrink-0">
        {!showModal && (
          <Image
            src={menu}
            alt="menu"
            width={26}
            height={22}
            className="block lg:hidden cursor-pointer"
            onClick={() => {
              if (pathname.includes("/business/dashboard")) {
                setShowDashboardSidebar(!showDashboardSidebar);
              } else if (pathname.includes("/business/event")) {
                setShowEventSidebar(!showEventSidebar);
              } else {
                setShowModal(!showModal);
              }
            }}
          />
        )}

      </div>
      {showModal && (
        <div
          ref={menuRef}
          className="glass-effect w-full min-h-screen flex flex-col px-5 py-6 fixed right-0 top-0 z-100 shadow-[0px_0px_12px_0px_rgba(0,0,0,0.12)] rounded-b-[20px]"
        >
          <div className="flex justify-start items-center w-full mb-4">
            <svg
              onClick={() => {
                setShowModal(false);
              }}
              className="cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 15L8 8L15 15M15 1L7.99867 8L1 1"
                stroke="#d9ac4f"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <ul className="w-full flex flex-col gap-2 justify-between items-start text-[#D1D3D4] text-[20px] font-medium">
            <Link
              href={"/"}
              className={`text-[20px] font-bold pb-2 ${
                pathname === "/"
                  ? "text-[#d9ac4f] border-b-2 border-[#D4AF37] rounded-[2px] drop-shadow-[0_0_8px_#d9ac4f]"
                  : ""
              }`}
            >
              {t("mobileMenuHeader.events")}
            </Link>
            {showStore === 1 && (
              <Link
                href={"/store"}
                className={`text-[20px] font-bold pb-2 ${
                  pathname === "/store"
                    ? "text-[#d9ac4f] border-b-2 border-[#D4AF37] rounded-[2px] drop-shadow-[0_0_8px_#d9ac4f]"
                    : ""
                }`}
              >
                {t("store.storeName")}
              </Link>
            )}
            {header_categories?.map((res: any) => (
              <div
                key={res.id}
                className="relative group w-full flex flex-col justify-start glass-effect items-center p-2 hover:bg-[#d9ac4f14] rounded"
              >
                <div
                  onClick={() => setOpen((prev) => (prev === "" ? res.id : ""))}
                  className="w-full flex justify-between glass-effect items-center"
                >
                  <Link
                    href={
                      res?.sub_categories.length !== 0
                        ? "#"
                        : `/category/${res?.slug}`
                    }
                    className={`pb-2 text-nowrap ${
                      pathname === `/category/${res?.slug}` || pathname.includes(`/category/${res?.slug}`)
                        ? "text-[#d9ac4f] border-b-2 border-[#D4AF37] rounded-[2px] drop-shadow-[0_0_8px_#d9ac4f]"
                        : ""
                    }`}
                  >
                    {res?.title === "الأكثر مبيعًا"
                      ? t("newHome.bestSelling")
                      : res?.title === "تذاكر دخول الموسم"
                      ? t("newHome.seasonEntryTickets")
                      : res?.title}
                  </Link>
                  {res?.sub_categories.length !== 0 && (
                    <Image
                      src="/dropdownicon.svg"
                      alt=""
                      width={10}
                      height={10}
                      className={
                        open === res.id ? "rotate-180 duration-200" : " "
                      }
                    />
                  )}
                </div>

                {res?.sub_categories.length !== 0 && open === res.id && (
                  <div
                    className={` w-full flex-nowrap  
                                   border-[#B8C0CB]  flex flex-col gap-1 justify-start items-start h-fit 
                                   glass-effect p-2 
                                   `}
                  >
                    {res.sub_categories.map((ev: any, index: any) => {
                      return (
                        <Link
                          key={ev?.id}
                          href={`/${ev.link}`}
                          className={`text-[#D1D3D4]  w-full rounded text-[12px] 
                                          p-2 glass-effect hover:bg-[#d9ac4f14] hover:text-[#d9ac4f]`}
                        >
                          {ev.title}
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
            <Link
              href={"/blog"}
              className={`pb-2 text-nowrap ${
                pathname === "/blog"
                  ? "text-[#d9ac4f] border-b-2 border-[#D4AF37] rounded-[2px] drop-shadow-[0_0_8px_#d9ac4f]"
                  : ""
              }`}
            >
              {t("mobileMenuHeader.articles")}
            </Link>
            <button
              // href={
              //   profile?.is_business
              //     ? "/business/dashboard"
              //     : "/business/register"
              // }
              onClick={() => {
                      if (token) {
                        profil?.is_business
                          ? window.location.href = "/business/dashboard"
                          : window.location.href = "/business/register"
                      } else {
                        window.localStorage.setItem("note", "business")
                        setModalIsOpen(true)
                      }
                    }}
              className={`pb-2 text-nowrap ${
                pathname.startsWith("/business")
                  ? "text-[#d9ac4f] border-b-2 border-[#D4AF37] rounded-[2px] drop-shadow-[0_0_8px_#d9ac4f]"
                  : ""
              }`}
            >
              {t("mobileMenuHeader.goldenTicketForBusiness")}
            </button>
          </ul>
        </div>
      )}
      {showDashboardSidebar && (
        <DashboardSidebar setShowDashboardSidebar={setShowDashboardSidebar} />
      )}
      {showEventSidebar && (
        <EventSidebar setShowEventSidebar={setShowEventSidebar} />
      )}
    </div>
  );
};

export default MobileMenuHeader;
